import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../AdminPanel.css";
import SuperAdminSidebar from "../SuperAdminSidebar";
import ManagerSidebar from "../ManagerSidebar";
import LeaderSidebar from "../LeaderSidebar";
import MemberSidebar from "../MemberSidebar";
import AdminNavbar from './AdminNavbar';

const CreateAccount = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [users, setUsers] = useState([]);
    const [editUserId, setEditUserId] = useState(null);
    const [editData, setEditData] = useState({});
    const [newUser, setNewUser] = useState({
        fname: "",
        lname: "",
        username: "",
        email: "",
        password: "",
        image: null,
        usertype: "member",
        status: "Select Status"
    });

    useEffect(() => {
        // Get user data from localStorage
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        console.log(storedUserType); // Log to ensure it's retrieved correctly
        if (!storedUserType) {
            navigate("/login"); // Redirect if not logged in
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            // Combine first and last name if available
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    // Logout function
    const logout = () => {
        // Clear session data from localStorage
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");

        // Redirect to login page after logout
        navigate("/login");
    };

    const fetchUsers = () => {
        fetch("https://skcapi.btcjapan.co/fetch_users.php")
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setUsers(data.Users);
                }
            })
            .catch(error => console.error("Error fetching users:", error));
    };

    const handleEdit = (user) => {
        setEditUserId(user.id);
        setEditData(user);
    };

    const handleChange = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        fetch("https://skcapi.btcjapan.co/update_user.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editData),
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status === "200") {
                    setEditUserId(null);
                    fetchUsers();
                } else {
                    console.error("Error updating user:", data.Message);
                }
            })
            .catch(error => console.error("Error updating user:", error));
    };

    const handleCancel = () => {
        setEditUserId(null);
        setEditData({});
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            fetch("https://skcapi.btcjapan.co/delete_user.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            })
                .then(response => response.json())
                .then(data => {
                    if (data.Status === "200") {
                        fetchUsers();
                    } else {
                        console.error("Error deleting user:", data.Message);
                    }
                })
                .catch(error => console.error("Error deleting user:", error));
        }
    };

    const handleRegisterChange = (e) => {

        const { name, value, files } = e.target;

        if (name === "image") {

            setNewUser({
                ...newUser,
                image: files[0]
            });

        } else {

            setNewUser({
                ...newUser,
                [name]: value
            });

        }

    };

    const handleRegister = (e) => {

        e.preventDefault();

        const formData = new FormData();

        formData.append("fname", newUser.fname);
        formData.append("lname", newUser.lname);
        formData.append("username", newUser.username);
        formData.append("email", newUser.email);
        formData.append("password", newUser.password);
        formData.append("usertype", newUser.usertype);
        formData.append("status", newUser.status);

        if (newUser.image) {
            formData.append("image", newUser.image);
        }

        fetch("https://skcapi.btcjapan.co/register_user.php", {

            method: "POST",
            body: formData

        })
        .then(res => res.json())
        .then(data => {

            if (data.Status === "200") {

                fetchUsers();

                setNewUser({

                    fname:"",
                    lname:"",
                    username:"",
                    email:"",
                    password:"",
                    image:null,
                    usertype:"member",
                    status:"Pending"

                });

            }

        });

    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
              {userType === "administrator" && <SuperAdminSidebar />}
              {userType === "leader" && <LeaderSidebar />}
              {userType === "manager" && <ManagerSidebar />}
              {userType === "member" && <MemberSidebar />}
            </div>

            <div className="admin-content">
                {/* Use the new AdminNavbar component */}
                <AdminNavbar />

                <div className="main-section">
                    <h3 className='section-title'>Create new account</h3>
                
                <form onSubmit={handleRegister}>
                    <div className="row g-3">
                        <div className="col-md-6">
                            <label className="form-label">First Name</label>
                            <input type="text" name="fname" className="form-control" value={newUser.fname} onChange={handleRegisterChange} required />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Last Name</label>
                            <input type="text" name="lname" className="form-control" value={newUser.lname} onChange={handleRegisterChange} required />
                        </div>
                    </div>
                    <div className="mt-3">
                        <label className="form-label">Username</label>
                        <input type="text" name="username" className="form-control" value={newUser.username} onChange={handleRegisterChange} required />
                    </div>
                    <div className="mt-3">
                        <label className="form-label">Email</label>
                        <input type="email" name="email" className="form-control" value={newUser.email} onChange={handleRegisterChange} required />
                    </div>
                    <div className="mt-3">
                        <label className="form-label">Password</label>
                        <input type="password" name="password" className="form-control" value={newUser.password} onChange={handleRegisterChange} required />
                    </div>
                    <div className="mt-3 row">
                        <div className="col-md-6">
                            <label className="form-label">User Type</label>
                            <select name="usertype" className="form-select" value={newUser.usertype} onChange={handleRegisterChange}>
                                <option value="administrator">Administrator</option>
                                <option value="leader">Leader</option>
                                <option value="manager">Manager</option>
                                <option value="member">Member</option>
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Status</label>
                            <select name="status" className="form-select" value={newUser.status} onChange={handleRegisterChange}>
                                <option value="">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Pending">Pending</option>
                            </select>
                        </div>
                    </div>
                    <div className="mt-3">
                        <label className="form-label">
                            Profile Image
                        </label>

                        <input
                            type="file"
                            name="image"
                            className="form-control"
                            accept="image/*"
                            onChange={handleRegisterChange}
                        />
                    </div>

                    <div className="mt-4 text-center">
                        <button type="submit" className="btn btn-primary px-5">Register</button>
                    </div>
                </form>
            </div>
        </div>
        </div >
    );
};

export default CreateAccount;
